var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMapThin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5004 4.85912C9.5004 7.26612 5.0004 13.5001 5.0004 13.5001C5.0004 13.5001 0.500397 7.26612 0.500397 4.85912C0.500397 2.45112 2.5154 0.500122 5.0004 0.500122C7.4844 0.500122 9.5004 2.45112 9.5004 4.85912Z",
    stroke: "#2E3742"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44971 4.50459C3.44971 3.64859 4.14371 2.95459 5.00071 2.95459C5.85571 2.95459 6.55071 3.64859 6.55071 4.50459C6.55071 5.36059 5.85571 6.05459 5.00071 6.05459C4.14371 6.05459 3.44971 5.36059 3.44971 4.50459Z",
    stroke: "#2E3742"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMapThin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MapThin.f24c33e2.svg";
export { ForwardRef as ReactComponent };